module.exports = __webpack_public_path__ + "static/img/VILLA-MAPLE.e04d2ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/VILLA-MAPLE.png
// module id = kvyZ
// module chunks = 0